module.exports = __webpack_public_path__ + "img/brand (1).393a25d0.svg";